export enum SubscriptionPaymentPeriod {
  MONTHLY = 'MONTHLY',
  ANNUALLY = 'ANNUALLY',
}
